import angular = require("angular");
import TPL = require("templates");
import {SessionService} from "../../services/session";

declare var FB: any;

export class FacebookLoginDirective {

  scope;
  template;
  link;

  constructor(session: SessionService, $modal, $rootScope, $log) {
    this.template = TPL.navigationDirectives.facebookLogin;
    this.scope = {
      name: "=name",
      value: "=value"
    }

    this.link = (scope, el, attrs)=> {
        scope.vm = {
          session: session,
          facebook: FB,
          loginWithFacebook: () => {

            FB.login(function(responseLogin) {
                $log.debug(responseLogin);
                session.loginWithFb(responseLogin.authResponse.userID, responseLogin.authResponse.accessToken)
                       .then(() => {

                       });
            }, {scope: 'public_profile, email'});
          },
        };
    }
  }

  static factory() {
    var tmp = (a, b, c, d) => new FacebookLoginDirective(a, b, c, d);
    tmp.$inject = ["session", "$uibModal", "$rootScope", "$log"];
    return tmp;
  }

  makeFbLogin() {
    FB.login(function(response) {
        this.session.loginWithFb(response.userID, response.accessToken);
    });

  }
}



/** WEBPACK FOOTER **
 ** ./src/scripts/directives/navigation/facebookLogin.ts
 **/